import React from 'react';
import { Box, TextHeadingTwo } from '@cko/primitives';
import styled from 'styled-components';
import Logo from './Logo';
const Layout = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: var(--layout-stadium);
  align-items: center;
`;
const LogoWrapper = styled.div `
  width: 160px;
`;
const Content = styled.div `
  padding: var(--layout-shoebox);
  margin-top: var(--layout-shoe);
  width: calc(4 * var(--layout-saturn));
  border-radius: var(--border-r-shoe);
  border: var(--border-b-seed) solid var(--base-border-secondary);
`;
export const LoginLayout = ({ children, title }) => {
    return (React.createElement(Layout, null,
        React.createElement(LogoWrapper, { "data-testid": "logo" },
            React.createElement(Logo, null)),
        React.createElement(Content, null,
            React.createElement(Box, null,
                title && (React.createElement(TextHeadingTwo, { "data-testid": "panel-title", mb: "var(--layout-shoe)" }, title)),
                children))));
};
